<template>
  <div id="app" spellcheck="false">
    <!-- 路由占位符 -->
    <router-view ></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
     
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    reload () {
     
    }
  }
}
</script>

<style>
body{
  margin: 0px;
}
/* 覆盖所有输入框的焦点样式
.el-input__wrapper.is-focus,
.el-textarea__inner:focus,
.el-select .el-input__wrapper.is-focus {
  border-color: #ff8a5c !important;
}

覆盖单选和复选框
.el-radio__input.is-checked .el-radio__inner,
.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #ff8a5c !important;
} */
</style>
